import { almostEqual } from "./helpers";
import { NodeComponentType, TubeType, } from "store/scene/types.current";
/* Which way an attachment arrow points when its port axis is vertical and has
 * to be flattened onto the horizontal plane. A central pump sits behind the
 * object at `centralizedVacuumPumpDefaultZ` with the feed pressure point
 * further back, so its compressed air arrives from -Z and its vacuum leaves
 * towards the grip positions at +Z — the same directions the placeholders of
 * every central pump with horizontal ports (PCS, PC23S-2, the Vacuum Pump Mini
 * siblings, the generic models) already point in. Anything else with an upward
 * port is the far end of that vacuum tube — the tube port on top of a cup — and
 * keeps pointing back towards the pump. */
var flattenedArrowZ = function (_a) {
    var nodeType = _a.nodeType, tubeType = _a.tubeType;
    return nodeType === NodeComponentType.CENTRALIZED_VACUUM_PUMP &&
        tubeType === TubeType.VACUUM
        ? 1
        : -1;
};
/* The arrow for an attachment points along its placeholder's own axis, out of
 * the port: the placeholder faces into the pump body, so the arrow follows the
 * negated forward vector.
 *
 * A port that faces straight up leaves the arrow aimed at the camera in the
 * top-down edit view, where it reads as no direction at all, so those are
 * flattened onto the horizontal plane by role (see `flattenedArrowZ`). The
 * Vacuplus Midi x1/x2 are the only central pumps whose vacuum outlet sits on
 * top of the housing; flattening it to a fixed -Z aimed it backwards, the same
 * way as its own compressed air arrow.
 *
 * Only the arrow is flattened — the tube itself still follows the true, upward
 * port axis and curves over the body (see `connectNodes`). */
export var getAttachmentArrowDirection = function (placeholderForward, attachment) {
    var direction = {
        x: -placeholderForward.x,
        y: -placeholderForward.y,
        z: -placeholderForward.z,
    };
    var pointsStraightUp = almostEqual(direction.y, 1) &&
        almostEqual(direction.x, 0) &&
        almostEqual(direction.z, 0);
    if (!pointsStraightUp)
        return direction;
    return { x: 0, y: 0, z: flattenedArrowZ(attachment) };
};
